import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isAdminSelector, userSelector } from 'redux/selectors/userSelector';
import { projectSelector } from 'redux/selectors/projectSelector';
import { Redirect, useParams } from 'react-router-dom';
import { CollaboratorPermission } from 'api';
import { Spin } from 'antd';
import { AppDispatch } from 'redux/store';
import { getProject } from 'redux/reducers/projectsSlice';

type ParamsProps = {
	projectId: string;
};

export default function withPermissionCheck(
	Component: React.FC,
	requiredPermission: CollaboratorPermission,
) {
	return function () {
		const userData = useSelector(userSelector);
		const projectId = parseInt(useParams<ParamsProps>().projectId);

		const dispatch: AppDispatch = useDispatch();
		const projectInfo = useSelector(projectSelector);
		if (!projectInfo) {
			dispatch(getProject(projectId));
		}

		const isAdmin = useSelector(isAdminSelector);
		const isUserAllowed = () =>
			userData?.projectPermissions
				?.find((x) => x.projectId === projectId)
				?.permissions?.includes(requiredPermission);

		if (!projectId) return <Spin />;

		if (isUserAllowed() || isAdmin) {
			return <Component />;
		}
		return <Redirect to={`/project/${projectId}`} />;
	};
}
